/**
 * @generated SignedSource<<af327182357a577116afe9aefbaa460e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PackageEditTransportFlightsRowActions_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PackageDateAddFlightDialog_data">;
  readonly " $fragmentType": "PackageEditTransportFlightsRowActions_data";
};
export type PackageEditTransportFlightsRowActions_data$key = {
  readonly " $data"?: PackageEditTransportFlightsRowActions_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PackageEditTransportFlightsRowActions_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PackageEditTransportFlightsRowActions_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PackageDateAddFlightDialog_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "6fbb8abceb5b7576ce09b7b96deaf38c";

export default node;
